import { css } from "lit-element";

export const style = css`
	:host {
		display: block;
		height: 40px;
		width: 40px;
		line-height: 40px;
		margin: 2px 0 2px 10px;
		padding: 5px;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color: var(--app-white);
		border: 5px solid var(--user-circle-image-br-color);
		background-color: var(--user-circle-image-bg-color);

		border-radius: 50%;
	}

	:host([large]) {
		height: 60px;
		width: 60px;
		line-height: 60px;
		font-size: 18px;
	}
	:host .image {
		display: block;
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}
`;
